import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps as DialogPropsType,
  DialogTitle,
  Theme,
  withStyles,
  ButtonProps,
  WithStyles,
  createStyles,
} from "@material-ui/core";
import React, { Fragment, useState } from "react";

import DialogConfig from "./DialogConfig.interface";
import DialogContext from "./DialogContext";

const styles = createStyles({
  verticalActions: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
});

interface Props {
  children: React.ReactNode;
  DialogProps?: DialogPropsType;
  ButtonProps?: ButtonProps;
  theme: Theme;
}

const DialogProvider = ({
  children,
  classes,
  DialogProps,
  ButtonProps,
  theme,
}: Props & WithStyles<typeof styles>) => {
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState<DialogConfig | null>();

  /**
   * Displays a dialog with helpful text and an action
   * @param dialogConfig
   */
  const showMessage = (dialogConfig: DialogConfig) => {
    setOpen(true);
    setConfig(dialogConfig);
  };

  const handleActionAndClose = (action?: () => void) => {
    if (action) {
      action();
    }
    setOpen(false);
  };

  return (
    <Fragment>
      <DialogContext.Provider value={showMessage}>
        {children}
      </DialogContext.Provider>
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={open}
        onClose={() => setOpen(false)}
        onExited={() => setConfig(null)}
        {...DialogProps}
      >
        <DialogTitle id="alert-dialog-title">{config?.title}</DialogTitle>
        <DialogContent>
          <DialogContentText color="textPrimary">
            {config?.message}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          className={
            config?.actionsLayout === "vertical"
              ? classes.verticalActions
              : undefined
          }
        >
          {config?.actions?.map((action) => (
            <Button
              key={action.label}
              style={
                action.color
                  ? { color: theme.palette[action.color]?.main }
                  : undefined
              }
              onClick={() => handleActionAndClose(action.action)}
              autoFocus={action.autoFocus}
              {...ButtonProps}
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default withStyles(styles, { withTheme: true })(DialogProvider);
